import { z } from 'zod';

// Invoice Schema
export const InvoiceSchema = z.object({
  invid: z.number().optional(),
  invcid: z.number().nullable(),
  invjid: z.number().nullable(),
  invjrid: z.number().nullable(),
  invuid: z.number().nullable(),
  invdate: z.string().nullable(),
  invdatedue: z.string().nullable(),
  invsent: z.string().nullable(),
  invopen: z.string().nullable(),
  invaccept: z.string().nullable(),
  invstatus: z.string().nullable(),
  invtype: z.string().nullable(),
  invmarkup: z.number().nullable(),
  invtotal: z.number().nullable(),
  invnocharge: z.number().default(0),
  invexpenses: z.number().nullable(),
  invexpensesdone: z.number().default(0),
  invexpensesdonedts: z.string().nullable(),
  invcommdone: z.number().default(0),
  invcommdonedts: z.string().nullable(),
  invkey: z.string().nullable(),
  invreason: z.string().nullable(),
  invreasonnotes: z.string().nullable(),
  invcommuid: z.number().nullable(),
  invcommtot: z.number().nullable(),
  invcommdts: z.string().nullable(),
  invcommtot2: z.number().nullable(),
  invcommdts2: z.string().nullable(),
  invprofit: z.number().nullable(),
  iqbid: z.number().nullable(),
  iqbstat: z.number().default(0),
  iqbinvoicenum: z.string().nullable(),
  iqbresp: z.string().nullable(),
  iqbitem: z.string().nullable(),
  invnolate: z.number().nullable(),
  invpaidfull: z.string().nullable(),
  invpaidfulldts: z.string().nullable(),
  invpaidchg: z.number().default(0),
  invamtchg: z.number().default(0),
  invlatefee: z.number().default(0),
  invpaid: z.number().default(0),
  invpays: z.string().nullable(),
  invpaysid: z.number().nullable(),
  invpaystatus: z.string().nullable(),
  invtm: z.number().default(0),
  invnoprices: z.number().default(1),
  invnoqtys: z.number().default(1),
});

// Create schema (omit auto-generated fields)
export const CreateInvoiceSchema = InvoiceSchema.omit({ invid: true });

// Update schema (make all fields optional except ID)
export const UpdateInvoiceSchema = InvoiceSchema.partial().required({ invid: true });

// Type definitions
export type Invoice = z.infer<typeof InvoiceSchema>;
export type CreateInvoice = z.infer<typeof CreateInvoiceSchema>;
export type UpdateInvoice = z.infer<typeof UpdateInvoiceSchema>; 